import { c as _c } from "react/compiler-runtime";
import { IcoShield16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import usePermissions from '@/hooks/use-permissions';

// Presentational banner, decoupled from the session so it can be exercised in isolation
// (Storybook / tests).
export const AuditorBannerContent = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "components.privateLayout.auditorBanner"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoShield16 color="warning" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="w-full sticky top-0 z-50 bg-warning text-warning text-body-2 max-w-full rounded-t flex items-center justify-center" role="alert"><div className="flex items-center gap-2 pt-2 pb-2.5">{t1}<span>{t2}</span></div></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const AuditorBanner = () => {
  const $ = _c(1);
  const {
    isAuditor
  } = usePermissions();
  if (!isAuditor) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AuditorBannerContent />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default AuditorBanner;
function _temp($) {
  return $.title;
}